<script lang="ts" setup>
const props = defineProps({
  data: {
    type: Object as () => Record<string, any>, // 指定 data 的類型為非空的物件
    required: true, // 告訴 TypeScript data 是必需的
  },
});
</script>

<template>
  <div class="card">
    <figure class="card__pic imh__opacity">
      <nuxt-link :to="data.link">
        <NuxtImg :src="data.image"></NuxtImg>
      </nuxt-link>
    </figure>
    <div class="card__item">
      <div class="card__middle">
        <div class="card__category">{{ data.category || '' }}</div>
        <div class="card__icon">
          <button class="card__fav card__icon__item buttonReset">
            <ButtonFavorite type="contest" :id="data.id" />
          </button>
          <button class="card__icon__item buttonReset">
            <ButtonShare class="card__icon__item" :link="data.link" />
          </button>
        </div>
      </div>
      <nuxt-link :to="data.link" class="card__titleEn">
        <div v-html="data.titleEn || ''"></div>
      </nuxt-link>
      <nuxt-link :to="data.link" class="card__titleTw">
        <div v-html="data.titleTw || ''"></div>
      </nuxt-link>
      <div class="card__deadline" v-if="!isNullOrEmptyOrUndefined(data.deadline)">
        {{ $t("deadline") }}{{ data.deadline }}
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.card {
  &__pic {
    width: 100%;
    margin-bottom: 35px;

    @include max-media(480) {
      margin-bottom: 20px;
    }

    img {
      display: block;
      width: 100%;
    }
  }

  &__item {
    width: 100%;
  }

  &__middle {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  &__category {
    font-size: 11px;
    color: rgba(0, 0, 0, 0.8);

    @include max-media(480) {
      font-size: 10px;
    }
  }

  &__titleEn {
    display: block;
    margin-bottom: 2px;
    color: rgba(0, 0, 0, 0.8);
    font-size: 16px;

    @include max-media(480) {
      font-size: 12px;
    }
  }

  &__titleTw {
    display: block;
    margin-bottom: 10px;
    font-size: 18px;
    color: #000;

    @include max-media(480) {
      font-size: 12px;
    }
  }

  &__deadline {
    margin-bottom: 20px;
    font-size: 14px;
    color: #999696;

    @include max-media(480) {
      font-size: 10px;
    }
  }

  &__icon {
    display: flex;
    align-items: center;

    &__item {
      width: 20px;
      height: 20px;

      @include max-media(480) {
        width: 13px;
        height: 13px;
      }

      &:not(:first-child) {
        margin-left: 10px;
      }
    }
  }

  a {
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
